const decodeApiMessage = (payload: any) => {
  console.log(payload);
  if (payload.errors) return payload.errors.join();
  if (payload.message) return payload.message;
  return null;
};

export default decodeApiMessage;
